module.exports = "https://r.nearpod.com/assets/media/image/trash-icon-e7a1b8ace1c009f9c06744a64a9d379a.svg";